<template>
  <b-row
    v-if="bannerAffiliator"
    class="bg-[#DFF3FF] p-1 mx-1 mb-1 rounded-lg justify-content-between"
  >
    <div>😊 Yuk tambahin saldo kamu dengan gabung jadi affiliator Komerce. Baca petunjuk
      <span>
        <a
          href="https://affiliate.komerce.id/"
          target="_blank"
          class="text-[#08A0F7]"
        >
          di sini
        </a>
      </span>
    </div>
    <img
      type="button"
      src="https://storage.googleapis.com/komerce/assets/svg/close-circle.svg"
      alt=""
      @click="bannerAffiliator = false"
    >
  </b-row>
</template>

<script>
export default {
  data() {
    return {
      bannerAffiliator: true,
    }
  },
}
</script>
